import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { set } from 'lodash';
import { ElementTemplate, Section } from '../../../DevlopmentOrder/PurchaseOrder/TemplateComponent';
import { checkArray } from '../../../../Components/helper';
import { usePOrderDetailState } from './PODetailProvider';
import RenderShippingDetails from './AllRenderTable/RenderShippingDetails';
import RenderCompanyDetails from './AllRenderTable/RenderCompanyDetails';
import RenderSupplierFactory from './AllRenderTable/RenderSupplierFactory';
import { commonPath } from '../../../DevlopmentOrder/PurchaseOrder/fieldPath';
import OrderDetailTable from './AllRenderTable/RenderOrderDetail';

function RenderAllSection() {
  const { poDetailstate, setPoDetailState, disablePoCondition } = usePOrderDetailState();
  const { templateJsonSchema } = poDetailstate;

  const handleSectionChange = async (value, keyName) => {
    const copyState = poDetailstate;
    let locate = '';
    if (keyName.includes('options')) {
      locate = keyName.split('.options');
    } else {
      locate = keyName.split('.value');
    }
    set(poDetailstate, `${locate[0]}.hasError.status`, false);
    await set(copyState, keyName, value);
    setPoDetailState((prevState) => ({ ...prevState, ...copyState }));
  };

  const templateRendering = (temp, i) => {
    switch (temp?.key) {
      case 'Supplier_factory':
        return (
          <Col lg={12} key={`RenderSupplierFactoryDetails_${temp?.key}_${temp?.id}_${i}`}>
            <RenderSupplierFactory data={temp} pIndex={i} />
          </Col>
        );
      case 'Shipping_Details':
        return (
          <Col lg={12} key={`RenderShippingDetails_${temp?.key}_${temp?.id}_${i}`}>
            <RenderShippingDetails data={temp} pIndex={i} />
          </Col>
        );

      case 'order_details':
        return (
          <Col lg={12} key={`RenderOrderDetail_${temp?.key}_${temp?.id}_${i}`}>
            <OrderDetailTable />
          </Col>
        );
      case 'Company_Details':
        return (
          <Col lg={12} key={`RenderCompanyDetails_${temp?.key}_${temp?.id}_${i}`}>
            <RenderCompanyDetails data={temp} pIndex={i} />
          </Col>
        );
      default:
        return (
          <Col lg={12} key={`Section_${temp?.key}_${temp?.id}_${i}`}>
            {temp?.key === 'Section' && (
              <Section prop={temp}>
                <Row className="span_font_size">
                  {temp?.columns.map((column, colIndex) => {
                    return (
                      <Col lg={6} key={colIndex}>
                        {column?.map((col, colChildIndex) => {
                          return (
                            <div className="py-1" key={col?.key}>
                              <ElementTemplate
                                {...col}
                                keys={col?.key}
                                onChange={handleSectionChange}
                                pIndex={i}
                                requiredField={col?.required}
                                disable={disablePoCondition}
                                error={col?.hasError}
                                options={col?.options}
                                placeHolder={col?.label}
                                value={col?.value}
                                path={
                                  col?.key === 'Check_Boxes'
                                    ? commonPath(i, colIndex, colChildIndex).COMPANY_DETAILS_CHECKBOX
                                    : commonPath(i, colIndex, colChildIndex).COMPANY_DETAILS
                                }
                              />
                            </div>
                          );
                        })}
                      </Col>
                    );
                  })}
                </Row>
              </Section>
            )}
          </Col>
        );
    }
  };
  return (
    <div>
      {checkArray(templateJsonSchema) &&
        templateJsonSchema.map((temp, i) => {
          return <Row key={`${temp?.key}_${temp?.id}`}>{templateRendering(temp, i)}</Row>;
        })}
    </div>
  );
}

export default RenderAllSection;
